import { useMutation } from '@apollo/client'
import { AddClearanceStatus, AddClearanceStatusVariables } from '../../types'
import { ADD_CLEARANCE_STATUS } from './operations'

export const useAddClearanceStatus = () =>
  useMutation<AddClearanceStatus, AddClearanceStatusVariables>(ADD_CLEARANCE_STATUS)
